import "react-toastify/dist/ReactToastify.css";
import { Router } from "react-router";
import { useSelector } from "react-redux";
import StyledToastContainer, {
  toastConfig,
} from "./utils/StyledToastContainer";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DayJSUtils from "@date-io/dayjs";
import esLocale from "dayjs/locale/es";
import { CssBaseline } from "@material-ui/core";
import { authRecoverSessionData } from "redux/auth/actions";
import { I18nProvider } from "./i18n";
import Routes from "./routes/Routes";
import Error from "layouts/Error";
import history from "routes/history";
import store from "redux/store";

store.dispatch(authRecoverSessionData());

const App = () => {
  const lang = useSelector(({ app }) => app.language.lang);
  const { error } = useSelector(({ auth }) => auth);

  return (
    <I18nProvider locale={lang}>
      <StyledToastContainer {...toastConfig} />
      <CssBaseline />
      {/* TODO: when internationalization is implemented this locale must be dynamic */}
      <MuiPickersUtilsProvider locale={esLocale} utils={DayJSUtils}>
        <Router history={history}>{!!error ? <Error /> : <Routes />}</Router>
      </MuiPickersUtilsProvider>
    </I18nProvider>
  );
};

export default App;
